var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEducation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.167 12.583V10.08c0-.15 0-.225-.023-.29a.418.418 0 0 0-.096-.156c-.05-.05-.116-.084-.25-.15L10 7.582m-6.667.834v5.672c0 .31 0 .465.049.6.042.12.112.229.203.318.104.1.244.165.526.294l5.334 2.444c.204.094.306.14.413.16.094.016.19.016.285 0 .106-.02.208-.066.413-.16l5.333-2.444c.282-.13.423-.194.526-.294a.833.833 0 0 0 .203-.318c.049-.135.049-.29.049-.6V8.417m-15-.834 8.035-4.017c.11-.055.164-.082.221-.093.051-.01.103-.01.154 0 .057.01.112.038.221.093l8.035 4.017-8.035 4.018a.902.902 0 0 1-.221.093.413.413 0 0 1-.154 0 .902.902 0 0 1-.221-.093L1.667 7.583Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgEducation;